import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { LOGO_URL, waLink, WA_DISPLAY } from "@/data/site";

const LINKS = [
  { href: "#beranda", label: "Beranda" },
  { href: "#artikel", label: "Artikel" },
  { href: "#tentang", label: "Tentang" },
  { href: "#keunggulan", label: "Keunggulan" },
  { href: "#katalog", label: "Katalog" },
  { href: "#kalkulator", label: "Kalkulator" },
  { href: "#lokasi", label: "Lokasi" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className="fixed inset-x-0 top-0 z-40 transition-all duration-500"
      style={{
        backgroundColor: scrolled ? "color-mix(in srgb, var(--t-dark) 85%, transparent)" : "transparent",
        backdropFilter: scrolled ? "blur(18px)" : "none",
        borderBottom: scrolled ? "1px solid color-mix(in srgb, var(--t-accent) 18%, transparent)" : "1px solid transparent",
      }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 lg:px-8">
        <a href="#beranda" className="flex items-center gap-3" data-testid="brand-logo-link">
          <img
            src={LOGO_URL}
            alt="Logo PT. SINAR AL MUBAROKAH"
            className="h-11 w-11 rounded-xl object-cover ring-2"
            style={{ "--tw-ring-color": "var(--t-accent)" }}
          />
          <span className="leading-tight">
            <span className="block font-serif text-base font-semibold tracking-wide text-[#F7EEDD]">
              PT. SINAR AL MUBAROKAH
            </span>
            <span className="block text-[10px] uppercase tracking-[0.22em] text-[#E0CFAF]/70">
              Distributor Kayu & Triplek
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#EFE3CC]/80 transition-colors duration-300 hover:text-[#FBF3E4]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-5 lg:flex">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-whatsapp-button"
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold transition-transform duration-300 hover:-translate-y-0.5"
            style={{ backgroundColor: "var(--t-accent)", color: "var(--t-dark)" }}
          >
            <MessageCircle size={16} /> {WA_DISPLAY}
          </a>
        </div>

        <button
          className="text-[#F3E9D6] lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="overflow-hidden lg:hidden"
            style={{ backgroundColor: "color-mix(in srgb, var(--t-dark) 95%, transparent)" }}
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-4 px-6 py-6">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-base font-medium text-[#F3E9D6]"
                >
                  {l.label}
                </a>
              ))}
              <div className="flex items-center justify-end pt-2">
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold"
                  style={{ backgroundColor: "var(--t-accent)", color: "var(--t-dark)" }}
                >
                  <MessageCircle size={15} /> WhatsApp
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
